<template>
<form class="feedback-form" @submit.prevent="onSubmit">
    <div class="field">
        <div class="control">
            <input
                v-model="text"
                class="input"
                placeholder="Your feedback..."
                maxLength="1000"
                :disabled="disableFeedback"
                required />
        </div>
    </div>
    <div class="field">
        <div class="control">
            <input
                v-model="email"
                type="email"
                class="input"
                placeholder="Your email (optional)"
                maxLength="100"
                :disabled="disableFeedback"/>
        </div>
    </div>
    <div class="field">
        <button
            :class="{ 'is-loading': isLoading }"
            class="button is-small"
            :disabled="disableFeedback">
            {{ btnText }}
        </button>
    </div>
</form>
</template>

<script>
export default {
    name: 'FeedbackForm',
    data: () => ({
        isLoading: false,
        text: '',
        email: '',
        btnText: 'Send Feedback',
        disableFeedback: false,
    }),
    methods: {
        async onSubmit () {
            try {
                this.isLoading = true
                const body = { text: this.text, email: this.email }
                await this.$api.post('feedback', body)

                this.btnText = 'Your feedback was submitted.'
                this.disableFeedback = true
            } catch (err) {
                this.btnText = 'Sorry, an error occurred.'
                Sentry.captureException(err)
            } finally {
                this.isLoading = false
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.feedback-form {
    margin-bottom: 1.5rem;
}
textarea {
    resize: none;
}
</style>
